import * as serviceCodeConf from 'confs/serviceCode_conf.json';
import { Fragment } from 'react';

const createServiceCodeSelect = (category) => {
    let rtn = []

    if (category === '0') {
        rtn.push( <option></option> );
        serviceCodeConf.services.forEach((obj, idx) => {
            rtn.push( <option key={idx}>{obj.label}</option> );
        })
    } else {
        rtn.push( <option key='0' selected>999 : その他</option> );
    }

    return (
        <Fragment>{ rtn }</Fragment>
    );
};

export default createServiceCodeSelect;